export default __webpack_public_path__ + "static/media/pch.7a1f781f.jpg";